<div class="@container">
  <div class="@[40rem]:hidden">
    <ng-container *ngTemplateOutlet="mobile"></ng-container>
  </div>
  <div class="hidden @[40rem]:block">
    <ng-container *ngTemplateOutlet="desktop"></ng-container>
  </div>
</div>

<ng-template #mobile>
  <div class="min-h-dvh">
    @if(categoryOrder().length > 1) {
      <div class="px-4 pb-4">
        <app-event-category-selector-list [categories]="categoryOrder()" [selectedCategory]="selectedCategory()"></app-event-category-selector-list>
      </div>
    }

    @switch (searchResults()?.length ?? null) {
      @case (null) {
        <ng-container *ngTemplateOutlet="mobileDefault"></ng-container>
      }
      @case (0) {
        <ng-container *ngTemplateOutlet="noSearchResults"></ng-container>
      }
      @default {
        <ng-container *ngTemplateOutlet="mobileSearchResults"></ng-container>
      }
    }

    <div class="h-4"></div>
  </div>
</ng-template>

<ng-template #mobileDefault>
  @if(featuredEvents().length > 1) {
    <app-event-card-carousel [events]="featuredEvents()"></app-event-card-carousel>
  }

  <div class="flex flex-col px-4 gap-y-2.5">
    @for(category of categoryOrder(); track category) {
      @if(categoryDistribution()[category].length > 1) {
        <app-event-category-section [category]="category" [events]="categoryDistribution()[category].slice(0, 4)"></app-event-category-section>
      }
    }
  </div>
</ng-template>

<ng-template #mobileSearchResults>
  <div class="flex flex-col px-4 gap-y-2.5">
    @for(event of searchResults(); track event.uniqueId) {
      <app-small-event-card [event]="event"></app-small-event-card>
    }
  </div>
</ng-template>

<ng-template #noSearchResults>
  <div class="text-center w-full max-w-screen-xl mx-auto p-5">
    <ng-container *transloco="let t">
      <h1 class="text-2xl font-bold">{{ t('home.noEvent') }}</h1>
    </ng-container>
  </div>
</ng-template>

<ng-template #desktop>
  <div class="min-h-header-safe">
    @switch (searchResults()?.length ?? null) {
      @case (null) {
        <div class="w-full">
          <ng-container *ngTemplateOutlet="desktopDefault"></ng-container>
        </div>
      }
      @case (0) {
        <div class="w-full">
          <ng-container *ngTemplateOutlet="noSearchResults"></ng-container>
        </div>
      }
      @default {
        <div class="w-full">
          <ng-container *ngTemplateOutlet="desktopSearchResults"></ng-container>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #desktopDefault>
  <div class="bg-[url('/assets/images/home-page-hero.webp')] bg-center bg-cover">
    <div class="flex flex-col items-center mx-[3rem] pb-[1.125rem]">
      <div class="w-full max-w-home-page">
        <div class="grid grid-cols-10">
          <div class="col-span-10 lg:col-span-6">
            <div class="py-4">
              @if(categoryOrder().length > 1) {
                <div class="w-full lg:hidden">
                  <app-event-category-selector-list [theme]="'light'" [categories]="categoryOrder()" [selectedCategory]="selectedCategory()"></app-event-category-selector-list>
                </div>
              }
            </div>

            @if(featuredEvents().length > 1) {
              <app-big-event-card-carousel [events]="featuredEvents()"></app-big-event-card-carousel>
            }
          </div>
          <div class="hidden lg:block lg:col-span-4 pl-16">
            <div class="h-full w-full flex flex-col justify-end items-start">
              <ng-container *transloco="let t">
                <span class="text-base text-white font-normal tacking-tighter">{{t('homePage.welcomeText')}}</span>

                <h1 class="text-4xl text-white font-bold tracking-tighter">{{t('homePage.motto')}}</h1>
              </ng-container>

              @if(categoryOrder().length > 1) {
                <div class="w-full overflow-x-hidden pt-4">
                  <app-event-category-selector-list [theme]="'light'" [categories]="categoryOrder()" [selectedCategory]="selectedCategory()"></app-event-category-selector-list>
                </div>
              }

              <div class="h-3.5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="h-2.5"></div>

  <div class="flex flex-col items-center mx-[3rem]">
    <div class="w-full max-w-home-page">
      <div class="flex flex-col gap-y-2.5">
        @for(category of categoryOrder(); track category; let i = $index; let last = $last) {
          @if(categoryDistribution()[category].length > 1) {
            <app-event-category-section [category]="category" [events]="categoryDistribution()[category].slice(0, 9)"></app-event-category-section>
          }
        }
      </div>
    </div>
  </div>

  <div class="h-[3rem]"></div>
</ng-template>

<ng-template #desktopSearchResults>
  <div class="@container flex flex-col items-center mx-12">
    <div class="@[49rem]:max-w-[49rem] @[74rem]:max-w-[74rem]">
      @if(categoryOrder().length > 1) {
        <div class="w-full my-4">
          <app-event-category-selector-list [categories]="categoryOrder()" [selectedCategory]="selectedCategory()"></app-event-category-selector-list>
        </div>
      }

      <div class="grid gap-[3rem] grid-cols-1 @[49rem]:grid-cols-2 @[74rem]:grid-cols-3">
        @for(event of searchResults(); track event.uniqueId;) {
          <app-event-card [event]="event"></app-event-card>
        }
      </div>
    </div>
  </div>

  <div class="h-12"></div>
</ng-template>
